import { Link } from 'react-router-dom';
import type { AnimeSeries } from '@/mocks/anime';

const genreColor: Record<string, string> = {
  奇幻: 'bg-primary-100 text-primary-700',
  冒险: 'bg-secondary-100 text-secondary-900',
  热血: 'bg-primary-100 text-primary-700',
  治愈: 'bg-secondary-100 text-secondary-900',
  日常: 'bg-secondary-100 text-secondary-900',
  音乐: 'bg-accent-100 text-accent-900',
  武侠: 'bg-accent-100 text-accent-900',
  古风: 'bg-accent-100 text-accent-900',
  战斗: 'bg-primary-100 text-primary-700',
  科幻: 'bg-secondary-100 text-secondary-900',
  机战: 'bg-secondary-100 text-secondary-900',
  成长: 'bg-accent-100 text-accent-900',
  校园: 'bg-accent-100 text-accent-900',
  恋爱: 'bg-primary-100 text-primary-700',
  青春: 'bg-accent-100 text-accent-900',
  悬疑: 'bg-secondary-100 text-secondary-900',
  推理: 'bg-secondary-100 text-secondary-900',
  都市: 'bg-primary-100 text-primary-700',
};

export default function AnimeCard({ anime }: { anime: AnimeSeries }) {
  return (
    <article className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-transform duration-300 hover:-translate-y-1">
      <Link to={`/anime/${anime.slug}`} className="relative block aspect-[3/4] w-full overflow-hidden bg-background-200">
        <img
          src={anime.cover}
          alt={`${anime.title}动漫分集剧情封面`}
          title={`${anime.title} 分集剧情解说`}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <span
          className={`absolute left-3 top-3 rounded-full px-2.5 py-1 text-xs font-medium ${
            anime.status === '连载中' ? 'bg-accent-500 text-background-50' : 'bg-background-50/90 text-foreground-800'
          }`}
        >
          {anime.status}
        </span>
        <span className="absolute right-3 top-3 inline-flex items-center gap-1 rounded-full bg-foreground-950/70 px-2.5 py-1 text-xs font-medium text-accent-300 backdrop-blur">
          <i className="ri-star-fill text-accent-400" /> {anime.rating.toFixed(1)}
        </span>
        <span className="absolute inset-x-0 bottom-0 flex items-center justify-center gap-2 bg-foreground-950/60 py-2 text-sm font-medium text-background-50 opacity-0 backdrop-blur transition-opacity duration-300 group-hover:opacity-100">
          <i className="ri-clapperboard-line" /> 查看分集剧情
        </span>
      </Link>

      <div className="flex flex-1 flex-col p-4 md:p-5">
        <div className="flex flex-wrap gap-1.5">
          {anime.genre.map((g) => (
            <span
              key={g}
              className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs ${genreColor[g] ?? 'bg-background-200 text-foreground-700'}`}
            >
              {g}
            </span>
          ))}
        </div>
        <h3 className="mt-2 font-heading text-base font-bold text-foreground-950 md:text-lg">
          <Link to={`/anime/${anime.slug}`} className="transition-colors hover:text-primary-600">
            {anime.title}
          </Link>
        </h3>
        <p className="mt-1 text-sm text-foreground-700 line-clamp-1">{anime.tagline}</p>
        <div className="mt-3 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-600">
          <span className="inline-flex items-center gap-1">
            <i className="ri-film-line text-primary-500" /> {anime.episodesCount} 话简介
          </span>
          <span className="inline-flex items-center gap-1">
            <i className="ri-calendar-line text-secondary-600" /> {anime.year}
          </span>
        </div>
      </div>
    </article>
  );
}